function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from "../components/Footer";
import { Button, Alert, notification, Result } from 'antd';
import Common from "./includes/Common";
import { HourglassSplit, Stopwatch } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TicketOrderResult = function TicketOrderResult() {
  var _useParams = useParams(),
    orderid = _useParams.orderid;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    transactionStatus = _useState2[0],
    setTransactionStatus = _useState2[1];
  useEffect(function () {
    if (orderid) {
      axios.get(Common.baseApiUrl + 'gettransactionstatus/' + orderid).then(function (response) {
        setTransactionStatus(response.data.status);
      })["catch"](function (e) {
        notification.error({
          message: "Erreur",
          description: "Impossible de verifier la transaction"
        });
      });
    }
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "lp-main-content",
      children: /*#__PURE__*/_jsx("div", {
        className: "s-box-wrapper",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              lg: 8,
              md: 8,
              sm: 12,
              children: [/*#__PURE__*/_jsxs("div", {
                className: "s-box  white-bg",
                children: [transactionStatus == 1 && /*#__PURE__*/_jsx(Result, {
                  status: "success",
                  title: "Paiement \xE9ffectu\xE9 avec succ\xE8s !",
                  subTitle: "Retouvez vos tickets dans l'onglet Mes tickets, depuis votre compte",
                  extra: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "VOIR MES TICKETS"
                    })
                  }, "console"), /*#__PURE__*/_jsx(Button, {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "ACCUEIL"
                    })
                  }, "buy")]
                }), transactionStatus == 2 && /*#__PURE__*/_jsx(Result, {
                  status: "error",
                  title: "Echec du paiement!",
                  subTitle: "Veuillez verifier votre compte et puis recommencer ...",
                  extra: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "REPRENDRE"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    href: "/#/home",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CONTINUER SUR LE SITE"
                    })
                  })]
                }), transactionStatus == 0 && /*#__PURE__*/_jsx(Result, {
                  icon: /*#__PURE__*/_jsx(HourglassSplit, {}),
                  title: "Paiement en cours ...",
                  subTitle: "Votre paiement est en cours de traitement ...",
                  extra: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    href: "/#/home",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CONTINUER SUR LE SITE"
                    })
                  })]
                }), transactionStatus == 3 && /*#__PURE__*/_jsx(Result, {
                  icon: /*#__PURE__*/_jsx(Stopwatch, {}),
                  title: "Transaction expir\xE9e",
                  subTitle: "Trop tard... La transaction a expir\xE9, veuillez essayer encore ...",
                  extra: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "REPRENDRE"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    href: "/#/home",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CONTINUER SUR LE SITE"
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx("br", {})]
            })
          })
        })
      })
    })
  });
};
export default TicketOrderResult;